module.exports = __webpack_public_path__ + "img/account-summary-history.51722145.svg";